import { useEffect, useState, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { MdClose } from "react-icons/md";
import Modal from "react-modal";
import Dropdown from "./Dropdown";
import ModalDataTable from "./ModalDataTable";
import useAxios from "../common/hook/useAxios";
import { toast } from "react-toastify";
import { AuthContext } from "../context/AuthContext";
import SearchBarWithSuggestions from "./SeachBarWithSuggestions";

const MyModal = ({
  modalIsOpen,
  setModalIsOpen,
  labsForDropdown,
  orderTypesForDropdown,
  templates,
  setSelectedLab,
}) => {
  const { request } = useAxios();
  const { user } = useContext(AuthContext);
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    watch,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      selectedLab: labsForDropdown[0]?.value || "",
      selectedOrderType: orderTypesForDropdown[0]?.value || "",
      selectedOrderCode: "",
      selectedIcd: "",
      templateName: "",
      selectedProvider: "",
    },
  });
  const [orderCodes, setOrderCodes] = useState([]);
  const [providers, setProviders] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [ICDsuggestions, setICDSuggestions] = useState([]);

  useEffect(() => {
    if (labsForDropdown.length > 0) {
      setValue("selectedLab", labsForDropdown[0]?.value);
      setSelectedLab(labsForDropdown[0]?.value);
    }
  }, [labsForDropdown, setValue, modalIsOpen]);

  useEffect(() => {
    if (providers.length > 0) {
      setValue("selectedProvider", providers[0]?.value || "");
    }
  }, [providers, setValue]);

  const closeModal = () => {
    reset();
    setModalIsOpen(false);
  };

  useEffect(() => {
    const params = { PracticeID: user?.PracticeID, SearchByRole: 1 };

    request(
      `${process.env.REACT_APP_DROPDOWN_DATA_URL}/GetPracticeProviders?sJSONInput=${JSON.stringify(params)}`,
      {
        method: "GET",
      },
    ).then((res) => {
      setProviders(
        Array.isArray(res) &&
          res.map((item) => ({
            label: item?.ProviderName,
            value: item?.ProviderID,
            ...item,
          })),
      );
    });
  }, []);
  const handleLabSelection = (selectedLab) => {
    setSelectedLab(selectedLab);
  };
  // useEffect(() => {
  //   if (user?.userID && watch("selectedLab")) {
  //     request(
  //       `${process.env.REACT_APP_TEMPLATES_URL}/LabTemplate/GetWithIcdAndOrderCode?sInputJSON={'PracticeID':${user?.practiceID},LabID:${watch("selectedLab")}}`,
  //       {
  //         method: "GET",
  //       },
  //     )
  //       .then((data) => {
  //         console.log(data, 'data sent');

  //         setTemplates(
  //           data
  //             // .filter((item1) => item1.labid == watch("selectedLab"))
  //             .map((item) => {
  //               console.log(item);

  //               return {
  //                 value: item.labTemplateID,
  //                 label: item.templateName,
  //                 ...item,
  //               };
  //             }),
  //         );
  //       })
  //       .catch(() => {
  //         toast.error("Error occured while fetching templates", {
  //           autoClose: 3000,
  //         });
  //       });
  //   }
  // }, [watch("selectedLab")]);

  useEffect(() => {
    const data = { LabID: watch("selectedLab"), SearchKey: watch("query") };
    if (watch("query")?.length > 0) {
      request(
        `${process.env.REACT_APP_ORDER_CODE_URL}/Search/SearchOrderCode?sInputJSON=${JSON.stringify(data)}`,
        {
          method: "GET",
        },
      )
        .then((data) => {
          setOrderCodes(
            data.map((item) => ({
              orderCode: item.OrderCode,
              name: item.OrderCodeDescription,
            })),
          );
        })
        .catch(() => {
          toast.error("Error occurred while fetching order codes", {
            autoClose: 3000,
          });
        });
    }
  }, [watch("selectedLab"), watch("query")]);

  useEffect(() => {
    if (watch("ICDquery")?.length > 0) {
      const data = { SearchKey: watch("ICDquery") };
      request(
        `${process.env.REACT_APP_ORDER_CODE_URL}/Search/ICD?sInputJSON=${JSON.stringify(data)}`,
        {
          method: "GET",
        },
      )
        .then((data) => {
          setICDSuggestions(
            data.map((item) => ({
              icdID: item.ICDID,
              icd9Code: item.ICD9Code,
              desc: item.Description,
            })),
          );
        })
        .catch(() => {
          toast.error("Error occurred while fetching ICDs", {
            autoClose: 3000,
          });
        });
    }
  }, [watch("ICDquery")]);

  useEffect(() => {
    if (watch("query")?.length > 0) {
      const filteredSuggestions = orderCodes.filter(
        (item) =>
          item?.orderCode
            ?.toLowerCase()
            .includes(watch("query").toLowerCase()) ||
          item?.name?.toLowerCase().includes(watch("query").toLowerCase()),
      );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  }, [watch("query")]);

  useEffect(() => {
    if (watch("ICDquery")?.length > 1) {
      const ICDfilteredSuggestions = ICDsuggestions.filter(
        (item) =>
          item?.icd9Code
            ?.toLowerCase()
            .includes(watch("ICDquery").toLowerCase()) ||
          item?.desc?.toLowerCase().includes(watch("ICDquery").toLowerCase()),
      );
      setICDSuggestions(ICDfilteredSuggestions);
    } else {
      setICDSuggestions([]);
    }
  }, [watch("ICDquery")]);

  const onSubmit = (data) => {
    const filteredProviders = providers.filter(
      (provider) => provider.ProviderID !== data.selectedProvider,
    );
    const formattedProviders = filteredProviders.map((provider) => ({
      physicianId: provider.ProviderID,
      physicianName: provider.ProviderName.replace(/ - /g, ""), // Remove trailing hyphens and spaces if needed
      physicianNPI: provider.NPI,
      physicianPhone: "", // Assuming this field is empty or not available
      physicianUPIN: "", // Assuming this field is empty or not available
    }));

    const data2 = {
      LabandOrderType: `${data.selectedLab}_${data.selectedOrderType}`,
      LabId: data.selectedLab,
      PracticeID: user.PracticeID,
      PhysicianId: formattedProviders[0].physicianId,
      PhysicianName: formattedProviders[0].physicianName,
      PhysicianNPI: formattedProviders[0].physicianNPI,
      PhysicianPhone: "",
      PhysicianUPIN: "",
      PracticeID: user?.PracticeID,
      TemplateName: data.templateName,
      dtLabTemplateICDDetails: [
        {
          LabTemplateID: 0,
          ICDCode: data.selectedIcd.icd9Code,
          ICDDescription: data.selectedIcd.desc,
          PracticeID: user?.PracticeID,
        },
      ],
      dtLabTemplateOrderDetails: [
        {
          LabTemplateID: 0,
          OrderCode: data.selectedOrderCode.orderCode,
          OrderCodeDescription: data.selectedOrderCode.name,
          OrderCodeIsProfile: 0,
          PracticeID: user?.PracticeID,
          // OrderCodeSpecimenType: 72 //hardcoded as it is not in form
        },
      ],
    };
    request(`${process.env.REACT_APP_TEMPLATES_URL}/LabTemplate`, {
      headers: {
        Authorization: `Bearer ${user.AuthToken}`,
        "Content-Type": "application/json",
      },

      method: "POST",
      data: JSON.stringify(JSON.stringify(data2)),
    })
      .then(() => {
        toast.success("Template saved successfully", { autoClose: 3000 });
        closeModal();
      })
      .catch(() => {
        toast.error("Error occurred while saving Template", {
          autoClose: 3000,
        });
      });
    // Handle form submission
  };
  const transformedData = templates.map((item, key) => [
    key + 1,
    item.templateName,
    item.physicianName,
    item.orderCode ? item.orderCode + "-" + item.orderCodeDescription : "N/A",
    item.icdCode || "N/A",
  ]);

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      className=" flex justify-center w-[110vh] relative m-auto"
      // className="fixed inset-0 flex items-center justify-center overflow-y-auto outline-none"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
    >
      <div className="relative bg-blue-100 rounded-lg shadow-lg p-6 w-full max-w-4xl mx-4 my-4 overflow-y-auto max-h-[90vh]">
        <button
          onClick={closeModal}
          className="absolute top-4 right-4 bg-red-500 text-white rounded-full p-2 hover:bg-red-600 focus:outline-none"
        >
          <MdClose size={24} />
        </button>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="mt-12 bg-blue-300 px-2">
            <Controller
              name="selectedLab"
              control={control}
              render={({ field }) => (
                <Dropdown
                  items={labsForDropdown}
                  label={"Lab:"}
                  // setSelectedValue={field.onChange}
                  setSelectedValue={(value) => {
                    field.onChange(value); // Update the Controller's state
                    handleLabSelection(value); // Pass the value to the parent
                  }}
                  value={field.value}
                />
              )}
            />
          </div>
          <div className="mt-2 px-2">
            <Controller
              name="selectedOrderType"
              control={control}
              render={({ field }) => (
                <Dropdown
                  items={orderTypesForDropdown}
                  label={"Order Type:"}
                  setSelectedValue={field.onChange}
                  value={field.value}
                />
              )}
            />
          </div>
          <div className="mt-2 bg-blue-300 px-2">
            <Controller
              name="selectedProvider"
              control={control}
              render={({ field }) => (
                <Dropdown
                  items={providers}
                  label={"Provider"}
                  setSelectedValue={field.onChange}
                  value={field.value}
                />
              )}
            />
          </div>
          <div className="mt-2 px-2 flex flex-col">
            <Controller
              name="query"
              control={control}
              rules={{ required: "Order code is required" }} // Validation rule
              render={({ field }) => (
                <SearchBarWithSuggestions
                  suggestions={suggestions}
                  value={field.value}
                  onChange={field.onChange}
                  onSelect={(item) => {
                    setValue("query", item.orderCode + " - " + item.name);
                    setValue("selectedOrderCode", item);
                  }}
                  placeholder="Search Order Code..."
                  keyNames={["orderCode", "name"]}
                />
              )}
            />
            <div className="w-full flex justify-end">
              {errors.query && (
                <p className="text-red-500 text-xs mt-2">
                  {errors.query.message}
                </p>
              )}
            </div>
          </div>
          <div className="w-full flex justify-end">
            <div className="mt-1 lg:w-1/2">
              <ModalDataTable
                headers={["Order Code", "Order Code Description"]}
                data={[watch("selectedOrderCode")]}
              />
            </div>
          </div>
          <div className="mt-2 px-2 bg-blue-300 flex flex-col">
            <Controller
              name="ICDquery"
              control={control}
              rules={{ required: "ICD is required" }} // Validation rule
              render={({ field }) => (
                <SearchBarWithSuggestions
                  suggestions={ICDsuggestions}
                  value={field.value}
                  onChange={field.onChange}
                  onSelect={(item) => {
                    setValue("ICDquery", item.icd9Code + " - " + item.desc);
                    setValue("selectedIcd", {
                      icd9Code: item.icd9Code,
                      desc: item.desc,
                    });
                  }}
                  placeholder="ICD:"
                  keyNames={["icd9Code", "desc"]}
                />
              )}
            />
            <div className="w-full flex justify-end">
              {errors.ICDquery && (
                <p className="text-red-500 text-xs mt-2">
                  {errors.ICDquery.message}
                </p>
              )}
            </div>
            <div className="w-full flex justify-end">
              <div className="mt-1 lg:w-1/2 text-base">
                <ModalDataTable
                  headers={["CPT Code", "CPT Description"]}
                  data={[watch("selectedIcd")]}
                />
              </div>
            </div>
          </div>
          <div className="flex mt-2 px-2 items-center justify-between text-md font-medium text-white-300 ">
            <>Template Name:</>
            <div className="flex flex-col">
              <input
                className="p-2 bg-white rounded-md shadow-sm  focus:outline-none focus:ring-2 focus:ring-blue-500"
                {...register("templateName", {
                  required: "Template Name is required",
                })}
              />
              <div className="w-full flex justify-end">
                {errors.templateName && (
                  <p className="text-red-500 text-xs mt-2">
                    {errors.templateName.message}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="w-full px-2 flex items-center justify-center">
            <button
              type="submit"
              className="bg-orange hover:bg-orange-600 mt-2 w-1/2 block text-md font-medium text-white p-2 rounded-lg"
            >
              Save
            </button>
          </div>
          <div className="mt-2 w-1/2 md:w-full">
            <ModalDataTable
              headers={["#", "Template Name", "Physician", "Order Code", "ICD"]}
              data={transformedData}
            />
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default MyModal;
